import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ExpandedState {
  expanded: Record<string, true>;
  toggle: (id: string) => void;
  expand: (id: string) => void;
  collapse: (id: string) => void;
  collapseAll: () => void;
  /** expand every ancestor folder of an item (reveal in tree) */
  expandPath: (ancestorIds: string[]) => void;
}

export const useExpanded = create<ExpandedState>()(
  persist(
    (set) => ({
      expanded: {},
      toggle: (id) =>
        set((s) => {
          const expanded = { ...s.expanded };
          if (expanded[id]) delete expanded[id];
          else expanded[id] = true;
          return { expanded };
        }),
      expand: (id) => set((s) => ({ expanded: { ...s.expanded, [id]: true } })),
      collapse: (id) =>
        set((s) => {
          const expanded = { ...s.expanded };
          delete expanded[id];
          return { expanded };
        }),
      collapseAll: () => set({ expanded: {} }),
      expandPath: (ancestorIds) =>
        set((s) => {
          const expanded = { ...s.expanded };
          for (const id of ancestorIds) expanded[id] = true;
          return { expanded };
        }),
    }),
    { name: "hn.tree-expanded" },
  ),
);
